import { Box, Chip, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";
import { useTranslation } from "react-i18next";

export const useSettingsCardSx = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return {
    p: 2.5,
    height: "100%",
    backgroundColor: colors.primary[400],
    borderRadius: "12px",
    border: `1px solid ${theme.palette.divider}`,
  };
};

export const SectionCard = ({ icon, title, children, sx }) => (
  <Box sx={sx}>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
      {icon}
      <Typography variant="h4" fontWeight={700}>
        {title}
      </Typography>
    </Box>
    {children}
  </Box>
);

export const SettingRow = ({ label, children, last, stacked }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: stacked ? "column" : "row",
        alignItems: stacked ? "stretch" : "center",
        justifyContent: "space-between",
        gap: stacked ? 1 : 2,
        py: 1.5,
        borderBottom: last ? "none" : `1px solid ${theme.palette.divider}`,
        flexWrap: "wrap",
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      <Box sx={{ minWidth: 0, maxWidth: "100%" }}>{children}</Box>
    </Box>
  );
};

export const SettingValue = ({ children }) => {
  const { t } = useTranslation();
  return (
    <Typography variant="h5" fontWeight={700}>
      {children || t("fields.notSet")}
    </Typography>
  );
};

export const StatusChip = ({ active, activeLabel, inactiveLabel }) => {
  const { t } = useTranslation();
  return (
    <Chip
      size="small"
      label={
        active
          ? activeLabel || t("common.active")
          : inactiveLabel || t("common.inactive")
      }
      sx={{
        fontWeight: 700,
        bgcolor: active ? "success.main" : "transparent",
        color: active ? "success.contrastText" : "text.secondary",
        border: "1px solid",
        borderColor: active ? "success.main" : "divider",
      }}
    />
  );
};

export const InfoChip = ({ label }) => (
  <Chip
    size="small"
    label={label}
    sx={{
      fontWeight: 700,
      bgcolor: "primary.main",
      color: "primary.contrastText",
    }}
  />
);
